import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TargetMessageService {

  private subject = new Subject<any>();

  sendMessage(topic: string, message: any) {
    this.subject.next({ topic: topic, message: message });
  }

  clearMessage() {
    this.subject.next();
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
